// eslint-disable-next-line import/no-internal-modules
import formatDateInLocalTimezone from '@insided/shared/utils/dateFormatting'

export interface LastEdited {
  last_edited_timestamp: number
  last_edited_by: string
}

const LastEditedCell = () => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  return ({ last_edited_timestamp, last_edited_by }: LastEdited) => {
    if (!last_edited_timestamp) {
      return null
    }

    return `${formatDateInLocalTimezone(last_edited_timestamp)} by ${last_edited_by}`
  }
}

export default LastEditedCell
